export const formatCurrency = {
  methods: {
    formatCurrency (number) {
      if (typeof number !== 'number') return ''
      const locale = this.$store.state.locale.selected
      const local = number.toLocaleString(locale, {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      })
      if (locale === 'fr-CA') {
        return `${local} $`
      } else {
        return `$${local}`
      }
    },
    formatSignedCurrency (number) {
      if (typeof number !== 'number') return ''
      const sign = number < 0 ? '-' : ''
      return `${sign}${this.formatCurrency(Math.abs(number))}`
    }
  }
}

export const getServiceDisplayPrice = {
  methods: {
    getServiceDisplayPrice (service) {
      const category = this.$store.getters.categoryById(service.category)
      if (
        category &&
        typeof category.serviceCategoryType === 'string' &&
        category.serviceCategoryType.toLowerCase() === 'pass'
      ) {
        return false
      } else if (service.category > '7') {
        return false
      } else if (
        (service.category === '1' || service.category === '2') &&
        !service.parentServiceId &&
        !service.subServices
      ) {
        return false
      } else if (service.category > '5' && !service.parentServiceId) {
        return false
      } else if (service.price === 0 && service.laborMatrixPayment) {
        if (service.laborMatrixPayment === 'NA' || service.laborMatrixPayment === 'None') {
          return this.formatCurrency(service.price)
        } else {
          return service.laborMatrixPaymentTranslations || ''
        }
      } else if (service.price === 0) {
        return this.$t('free')
      } else {
        return this.formatCurrency(service.price)
      }
    }
  }
}

export const getTotal = {
  methods: {
    getTotal (services) {
      let total = 0
      for (const service of services) {
        if (service.isSelected) {
          const category = this.$store.getters.categoryById(service.category)
          if (
            category &&
            typeof category.serviceCategoryType === 'string' &&
            category.serviceCategoryType.toLowerCase() === 'pass'
          ) {
            total += 0
          } else if (service.category > '7') {
            total += 0
          } else if (
            (service.category === '1' || service.category === '2') &&
            !service.parentServiceId &&
            !service.subServices
          ) {
            total += 0
          } else if (service.category > '5' && !service.parentServiceId) {
            total += 0
          } else if (service.price === 0 && service.laborMatrixPayment) {
            if (service.laborMatrixPayment === 'NA' || service.laborMatrixPayment === 'None') {
              total += service.price
            }
          } else if (service.price === 0) {
            total += 0
          } else {
            total += service.price
          }
        } else if (service.category === '4') {
          total += service.price
        }
      }
      return total
    }
  }
}

export const focus = {
  methods: {
    focus (selector) {
      const element = document.querySelector(selector)
      if (element) element.focus()
    }
  }
}

export const services = {
  methods: {
    services () {
      let services = []
      let recommendedService = []
      let count = 0
      for (const category of this.categoriesShown) {
        if (!this.isPass(category.id)) {
          services = services.concat(this.categoryServicesShownOnRoute(category.id))
        }
      }
      services.filter(service => (service.category !== '3'))
      services.forEach(service => {
        if (this.getServiceDisplayPrice(service) !== false) {
          recommendedService.push(service)
        }
      })
      recommendedService.forEach(service => {
        if (service.isApproveSelected || service.isDeferSelected) {
          count++
        }
      })
      return count === recommendedService.length
    }
  }
}
